import React, { useCallback } from 'react';

import { constants as modalConstants } from 'bdvp-graphql/src/resolvers/modals';
import {
    useReelStore,
    useUserData,
    useModalStore,
} from 'bdvp-common/src/hooks/store';

import Component from '../components/CreationModal';

const { REEL_CREATION_MODAL_NAME } = modalConstants;

const CreationModal = () => {

    const {
        data,
        validateReel,
        createReel,
        createReelLoading,
        createReelData,
        createReelError,
    } = useReelStore();

    const { data: userData = {} } = useUserData();
    const { userId = '' } = userData;

    const { modalHide } = useModalStore();

    const closeReelCreationModal = useCallback(() => modalHide(REEL_CREATION_MODAL_NAME), [modalHide]);

    return (
        <Component
            name={REEL_CREATION_MODAL_NAME}
            reel={data?.reel || {}}
            validateReel={validateReel}
            createReel={createReel}
            createReelLoading={createReelLoading}
            createReelData={createReelData}
            createReelError={createReelError}
            userId={userId}
            closeReelCreationModal={closeReelCreationModal}
        />
    );

};

export default CreationModal;
